import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "input-wr svg-file-wr" }
const _hoisted_14 = {
  key: 0,
  class: "svg-file-name"
}
const _hoisted_15 = { class: "input-row" }
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_18 = { class: "input-wr" }
const _hoisted_19 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = { class: "input-wr" }
const _hoisted_22 = { class: "input-wr" }
const _hoisted_23 = { class: "input-row" }
const _hoisted_24 = { class: "input-wr" }
const _hoisted_25 = { class: "input-wr" }
const _hoisted_26 = { class: "input-row" }
const _hoisted_27 = {
  key: 1,
  class: "spinner-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Create Lot Map")
    ], -1)),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Width", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.width.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.width) = $event)),
            type: "number",
            placeholder: "Width"
          }, null, 2), [
            [_vModelText, $setup.form.width]
          ]),
          ($setup.v$.width.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.width.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Height", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.height.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.height) = $event)),
            type: "number",
            placeholder: "Height"
          }, null, 2), [
            [_vModelText, $setup.form.height]
          ]),
          ($setup.v$.height.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.height.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Coordinate X", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.x.$error }]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.x) = $event)),
            type: "number",
            placeholder: "X"
          }, null, 2), [
            [_vModelText, $setup.form.x]
          ]),
          ($setup.v$.x.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.x.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Coordinate Y", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.y.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.y) = $event)),
            type: "number",
            placeholder: "Y"
          }, null, 2), [
            [_vModelText, $setup.form.y]
          ]),
          ($setup.v$.y.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.v$.y.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, "Lot SVG File", -1)),
          _createElementVNode("input", {
            class: "input",
            type: "file",
            accept: ".svg,image/svg+xml",
            onChange: $setup.onSvgFileChange
          }, null, 32),
          ($setup.form.svgFileName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.form.svgFileName), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Figure Path", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.path.$error }]),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.path) = $event)),
            type: "text",
            placeholder: "Figure Path"
          }, null, 2), [
            [_vModelText, $setup.form.path]
          ]),
          ($setup.v$.path.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.v$.path.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Status Figure Path", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.statusPath.$error }]),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.statusPath) = $event)),
            type: "text",
            placeholder: "Status Figure Path"
          }, null, 2), [
            [_vModelText, $setup.form.statusPath]
          ]),
          ($setup.v$.statusPath.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.v$.statusPath.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "House X", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.houseX) = $event)),
            type: "number",
            placeholder: "House X"
          }, null, 512), [
            [_vModelText, $setup.form.houseX]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label" }, "House Y", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.houseY) = $event)),
            type: "number",
            placeholder: "House Y"
          }, null, 512), [
            [_vModelText, $setup.form.houseY]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "House Width", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.houseWidth) = $event)),
            type: "number",
            placeholder: "House Width"
          }, null, 512), [
            [_vModelText, $setup.form.houseWidth]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label" }, "House Height", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.houseHeight) = $event)),
            type: "number",
            placeholder: "House Height"
          }, null, 512), [
            [_vModelText, $setup.form.houseHeight]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        (!$setup.loading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary create-btn",
              onClick: $setup.createMap,
              type: "button"
            }, "Create"))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
            ]))]))
      ])
    ])
  ], 64))
}